import Airtable from 'airtable';

export const martBase = new Airtable({
    apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
  }).base(process.env.REACT_APP_AIRTABLE_MART_BASE_ID);